import { Font } from '@/__generated__/graphql';
import Select from 'react-select';
import React, { useState } from 'react';
import { useSuspenseQuery } from '@apollo/client';
import { gql } from '@/__generated__';

const getAllFamiliesQuery = gql(`
  query getAllFamilies {
     font {
      getAllFamilies {
        ... on FontGetAllFamiliesSuccess {
          result {
            fonts {
              id
              italic
              name
              weight
              weightName
            }
          }
        }
      }
    }
  }
`);

interface FontsDropdownProps {
  selectedFontId?: string | null;
  onChange: (value: string) => void;
}

const FontsDropdown: React.FC<FontsDropdownProps> = ({
  selectedFontId,
  onChange,
}: FontsDropdownProps) => {
  const handleFontChange = (newValue: any | null) => {
    if (!newValue) {
      return null;
    }

    setValue(newValue);
    onChange(newValue.value);
  };
  const { data: allFamiliesdata } = useSuspenseQuery(getAllFamiliesQuery);
  const fonts = allFamiliesdata.font.getAllFamilies.result.flatMap(
    (fontFamilies) => fontFamilies.fonts
  );

  const initialValue = fonts?.find(
    (font: Partial<Font>) => font.id === selectedFontId
  );
  const [value, setValue] = useState<string | undefined>(initialValue?.name);
  const options = fonts.map((font) => ({ value: font.id, label: font.name }));

  return (
    <Select
      className='w-full'
      placeholder={'Select font'}
      options={options as any}
      onChange={(value) => handleFontChange(value)}
      defaultInputValue={value}
      value={value || null}
      components={{
        IndicatorSeparator: () => null,
      }}
    />
  );
};

export default FontsDropdown;
